import React from 'react';
import PropTypes from 'prop-types';

/**
 * Date Separator Component
 * Renders a floating pill with the date label
 */
export default function DateSeparator({ date }) {
    return (
        <div className="flex justify-center my-6">
            {/* inline divider chip — NOT sticky (multiple sticky chips pile up at the top) */}
            <span className="eyebrow eyebrow-10 bg-app-surface border border-border-subtle px-3 py-1">
                {date}
            </span>
        </div>
    );
}

DateSeparator.propTypes = {
    date: PropTypes.string.isRequired
};
